import React from "react";
import { useNavigate } from "react-router-dom";
import "./cancel.css";

const Cancel = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Navigate to the home page
    navigate("/");
  };

  return (
    <div className="cancel-container">
      <h1 className="cancel-heading">Payment Cancelled</h1>
      <p className="cancel-message">
        Unfortunately, your payment was cancelled. You can go back and try
        again if you wish.
      </p>
      <button className="cancel-button" onClick={handleGoHome}>
        Go to Home
      </button>
    </div>
  );
};

export default Cancel;

